import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Award, BookOpen, Briefcase, FileBadge, FileSignature, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/shared";
import { Combobox } from "@/components/shared/Combobox";

const OPTIONS = [
  { key: "corporate", icon: Award, title: "MarksMan corporate document", desc: "Our PAN, GST, MSME, TDS certificate, incorporation, bank letter, company profile, template", to: "/marksman-documents?tab=corporate&add=1" },
  { key: "certification", icon: ShieldCheck, title: "MarksMan certification", desc: "ISO or other certification with renewal history", to: "/marksman-documents?tab=certifications&add=1" },
  { key: "policy", icon: BookOpen, title: "Company policy", desc: "Policy library with versions and review dates", to: "/marksman-documents?tab=policies&add=1" },
  { key: "form", icon: FileBadge, title: "Client form / request", desc: "Vendor registration, questionnaire, declaration, invoicing instructions for a client", to: "/client-onboarding?tab=forms&add=1" },
  { key: "nda", icon: FileSignature, title: "Client NDA / CDA", desc: "Confidentiality agreement with a client", to: "/client-onboarding?tab=nda&add=1" },
  { key: "msa", icon: FileSignature, title: "Master Service Agreement", desc: "Client MSA, amendment or renewal", to: "/master-service-agreements?add=1" },
  { key: "project", icon: Briefcase, title: "Project document", desc: "RFP, SOW, estimate, PO / service agreement, deliverable, invoice or payment file for a project", to: null },
];

export const AddDocumentChooser = ({ open, onOpenChange, projects, onProject }) => {
  const nav = useNavigate();
  const [pick, setPick] = useState(null);
  const [pid, setPid] = useState("");
  useEffect(() => { if (open) { setPick(null); setPid(""); } }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="add-document-chooser">
        <DialogHeader><DialogTitle>Add Document — where does it belong?</DialogTitle><DialogDescription>Choose the section first; the matching form opens there so the file is stored once in the right place.</DialogDescription></DialogHeader>
        {pick !== "project" ? (
          <div className="grid sm:grid-cols-2 gap-2">
            {OPTIONS.map((o) => (
              <button key={o.key} type="button" data-testid={`add-doc-option-${o.key}`} onClick={() => (o.to ? (onOpenChange(false), nav(o.to)) : setPick("project"))}
                className="text-left rounded-md border border-slate-200 p-3 hover:border-teal-500 hover:bg-teal-50/40 transition-colors">
                <div className="flex items-center gap-2 text-sm font-medium text-slate-800"><o.icon className="h-4 w-4 text-teal-600" /> {o.title}</div>
                <div className="text-xs text-slate-500 mt-1">{o.desc}</div>
              </button>
            ))}
          </div>
        ) : (
          <div className="space-y-3">
            <Field label="Project" required><Combobox testid="pick-project-select" items={projects.map((x) => ({ value: x.id, label: `${x.project_code} · ${x.name}`, hint: x.client_name }))} value={pid} onChange={setPid} placeholder="Search project ID or name" /></Field>
            <div className="flex justify-between gap-2"><Button variant="ghost" onClick={() => setPick(null)}>Back</Button><Button className="bg-teal-600 hover:bg-teal-700" disabled={!pid} onClick={() => onProject(pid)} data-testid="pick-project-continue">Continue</Button></div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
